<div class="viewport-1" [style.background-image]="'url(' + interventionTaskService.taskBackgroundImage() + ')'">
  <student-header></student-header>
  <task-bar #taskBar [totalPoints]="taskTotalPoints"></task-bar>

  <div class="task-screen-element verify-the-blank-container" [style.background-image]="' ' + interventionTaskService.taskContainerColor() + ' '"
    [class]="(animationComplete || !animateContainer) ? 'taskShow' : 'taskHide'">
    <div class="testType font-18">{{interventionTaskService.testType()}}</div>
    <div class="timer-bar-container">
      <trial-timer-bar></trial-timer-bar>
      <button [class]="(hideTimer) ? 'replayVideo-no-timerbar' : 'replayVideo'" (click)="replayVideo()" [disabled]="disableAVButtons"></button>
    </div>
    <div class="word-to-verify">
      <div class="audio-controls-container no-margin-left">
        <button class="speaker" (click)="repeatWord()" [disabled]="disableAVButtons"></button>
        <button class="snail-button" (click)="playWordAudioSlowed()" [disabled]="disableAVButtons"></button>
      </div>
      <div class="verify-word font-42">
        {{targetWord}}
      </div>
    </div>
    <div class="response-row">
      <!--TODO: Check that these buttons are correctly match intervention task behavior-->
      <button [class]="(disableResponseButtons) ? 'verify-response-correct-grayed' : 'verify-response-correct'"
          [style.border-color]="' ' + interventionTaskService.highlightColor() + ' '" [disabled]="disableResponseButtons" (click)="submitAnswer(true)">
      </button>
      <button  class="next-trial-base"
          [class]="{'next-trial-hidden': hideNextButton || unmaskedTask, 'next-trial-grayed' : disableNextButton, 'next-trial' : !disableNextButton, 'toggle-next-on' : toggleNextButton}"
          [style]="{'border-color':' ' + interventionTaskService.highlightColor() + ' ', 'position': 'relative ', 'top': '-40% '}"
          [disabled]="disableNextButton"
          (click)="nextTrial()">
      </button>
      <button [class]="(disableResponseButtons) ? 'verify-response-incorrect-grayed' : 'verify-response-incorrect'"
          [style.border-color]="' ' + interventionTaskService.highlightColor() + ' '" [disabled]="disableResponseButtons" (click)="submitAnswer(false)">
      </button>
    </div>
  </div>
  @if (isDevMode) {
    <div>{{wordListAttempt}} - {{task.wordlistType}}</div>
  }

  <trial-counter [showCorrectIncorrect]="true" [taskAnimationComplete]="animationComplete"></trial-counter>
  <instructions [videoSource]="instructionalVideoFile"></instructions>
  <save-data-dialog (onSaveButtonClick)="saveTaskData()"></save-data-dialog>
  <focus-dialog></focus-dialog>
</div>
